// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"774":"9210fbda","787":"f03d659e","871":"21375f76"}[chunkId] + ".chunk.js";
};